import { ViewStyle, TextStyle } from "react-native"
import { color, dimensions, spacing, typography } from "../../theme"

/**
 * Container style
 */
export const VIEW: ViewStyle = {
  minWidth: 210,
  paddingHorizontal: spacing[4],
}

/**
 * Label text style
 */
export const TEXT: TextStyle = {
  fontFamily: typography.primary.regular,
  color: color.text,
  fontSize: 18,
}

export const BOLD_TEXT: TextStyle = {
  ...TEXT,
  fontFamily: typography.primary.bold,
  fontWeight: "bold",
}

export const POP_UP: ViewStyle = {
  padding: 0,
  borderRadius: dimensions.buttonRadius,
  borderWidth: 0,
  elevation: 2,
}

export const ITEM: ViewStyle = {
  ...VIEW,
  borderRadius: 0,
  width: "100%",
  borderWidth: 0,
  backgroundColor: color.background,
}

export const SPACER: ViewStyle = {
  flex: 1,
}

export const dropdownOptionPresets = {
  default: { ...ITEM },
  selected: {
    ...ITEM,
    backgroundColor: color.secondary,
  },
}

export type DropdownOptionPresetNames = keyof typeof dropdownOptionPresets
